import { Plus } from "lucide-react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "@pushpress/pushpress-ui";
import { handleAddClick } from "../../helpers";
import { PEOPLE_TYPE } from "../../types";

export default function AddPerson() {
  return (
    <div className="tw-flex tw-justify-between tw-items-center tw-mb-6 tw-mt-4">
      <h2 className="tw-text-2xl" data-testid="people-header">
        People
      </h2>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button data-testid="add-person-button">
            <Plus className="tw-mr-1 tw-h-4 tw-w-4" />
            Person
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => handleAddClick(PEOPLE_TYPE.LEADS)}>
            Lead
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleAddClick(PEOPLE_TYPE.MEMBERS)}>
            Member
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleAddClick(PEOPLE_TYPE.STAFF)}>
            Staff
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
